import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SidebarService } from 'src/app/sidebar/sidebar.service';

@Component({
  selector: 'app-integration-preview',
  templateUrl: './integration-preview.component.html',
  styleUrls: ['./integration-preview.component.scss'],
})
export class IntegrationPreviewComponent implements OnInit {
  integration: any;
  viewMode: 'mobile' | 'desktop' = 'mobile';

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private sidebarService: SidebarService,
  ) {}

  ngOnInit(): void {
    this.integration = this.activatedRoute.parent?.snapshot.data.integration;
    const providerType = this.integration?.provider?.type;
    const featureTypeByProvider: Record<string, string> = {
      aura_assistant: 'aura',
      tripist_assistant: 'tripist',
      explorist_assistant: 'explorist',
    };
    const featureType = featureTypeByProvider[providerType];
    if (featureType && this.integration?.id) {
      this.router.navigate(['/assistist', featureType, this.integration.id, 'preview'], { replaceUrl: true });
      return;
    }
    this.syncSidebarForAssistantPreview();
  }

  get providerName(): string {
    return this.integration?.provider?.name || 'Integration';
  }

  goBack(): void {
    this.router.navigate(['..'], { relativeTo: this.activatedRoute });
  }

  goToList(): void {
    this.router.navigate(['list'], {
      relativeTo: this.activatedRoute.parent?.parent,
    });
  }

  private syncSidebarForAssistantPreview(): void {
    const providerType = this.integration?.provider?.type;
    const sidebarCodeByProvider: Record<string, string> = {
      aura_assistant: 'aura',
      tripist_assistant: 'tripist',
      explorist_assistant: 'explorist',
    };
    const sidebarCode = sidebarCodeByProvider[providerType];
    if (sidebarCode) {
      this.sidebarService.setNavigationOpenOnChange(sidebarCode);
    }
  }
}
